import $ from 'jquery'


import component from './_import/_component'
import base from './_import/_base'
import matchMedia from './_import/_match-media'
import narrowViewport from './_import/_narrow-viewport'
import pagetop from './_import/_pagetop'
import tab from './_import/_tab'
import accordion from './_import/_accordion'
import modal from './_import/_modal'
import globalNav from './_import/_global-nav'
import isScrollbar from './_import/_isScrollbar'
import popupToggle from './_import/_popup-toggle'
import filterTab from './_import/_filter-tab'
import scrollhint from './_import/_scrollhint.js'
import clearCheckbox from './_import/_clear-checkbox.js'
import scrollAnimation from './_import/_scroll-animation.js'
import mvSlider from './_import/_mv-slider.js'
import pickupNews from './_import/_pickup-news.js'
import newsPulldown from './_import/_news-pulldown.js'
import newsPagination from './_import/_news-pagination.js'
import tokkyoExpand from './_import/_tokkyo-expand.js'
import strengthOrbit from './_import/_strength-orbit.js'
import cardCarousel from './_import/_card-carousel.js'
import formValidate from './_import/_form-validate.js'

component.set(base)
component.add('matchMedia', matchMedia)

narrowViewport.init()
pagetop.init()
globalNav.init()
// anchorLink.init();
tab.init()
accordion.init()
modal.init()
isScrollbar.init()
popupToggle.init()
filterTab.init()
scrollhint.init()
scrollhint.init()
clearCheckbox.init()
scrollAnimation.init()
mvSlider.init()
pickupNews.init()
newsPulldown.init()
// newsPagination.init()
tokkyoExpand.init()
strengthOrbit.init()
cardCarousel.init()
formValidate.init()

component.add('tab', tab)
component.add('modal', modal)
component.add('accordion', accordion)

const init = () => {
  $('html').removeClass('no-js')
}

init()

$(function () {
  /*
    ヘッダーのニュース。TOPには #news があるのでスクロールで飛ばし、
    #news を持たない下層ページではこのまま href の /news/ へ遷移させる
  */
  $('.js-scroll-to-news').on('click', function (e) {
    var $news = $('#news')
    if (!$news.length) return
    e.preventDefault()
    var $toggle = $('.js-header_toggle-open.is-active')
    if ($toggle.length) {
      $toggle.trigger('click')
      setTimeout(function () {
        $('html, body').animate({ scrollTop: $news.offset().top }, 600)
      }, 200)
    } else {
      $('html, body').animate({ scrollTop: $news.offset().top }, 600)
    }
  })

  $('a[href^="#"]').not('.p-tokkyo-anchor__tab, .p-inquiry-anchor__tab').on('click', function (e) {
    var hash = $(this).attr('href')
    if (hash === '#') return
    var $target = $(hash)
    if (!$target.length) return
    e.preventDefault()
    $('html, body').animate({ scrollTop: $target.offset().top }, 400)
  })
})
